import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {  ComboService } from '../../../services/combo.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { DocumentService } from '../../../services/document.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { Router, ActivatedRoute } from '@angular/router';
import { HoldersCvfDetailComponent } from '../holders-cvf-detail/holders-cvf-detail.component';
import { HoldersCvfRejectDialogComponent } from '../holders-cvf-reject-dialog/holders-cvf-reject-dialog.component';
import { HoldersCvfSignedUploadDialogComponent } from '../holders-cvf-signed-upload-dialog/holders-cvf-signed-upload-dialog.component';
import { CvfControllerService,
  CvfEstadosControllerService,
  CvfEstadoDTO,
  CvfDTO,
  CvfFilterDTO,
  PoseedorFilterDTO,
  PoseedorDTO,
  AportacionDIPoseedorControllerService,
  PoseedorEstadoControllerService,
  GestoresResiduosEstadosControllerService,
  DiccionarioControllerService,
  DiccionarioElementoDTO
 } from 'api-rest';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';

@Component({
  selector: 'lib-holders-cvf-search',
  templateUrl: './holders-cvf-search.component.html',
  styleUrls: ['./holders-cvf-search.component.scss']
})
export class HoldersCvfSearchComponent {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  headArrayModificado: any[] = [];

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  estadoArray: any[] = [];
  tipoCvfArray: any[] = [];
  cvfTypeFromRoute: string | null = null;
  private searchFormState: any;

  estadosGestorArray: any[] = [];
  estadosPoseedorArray: any[] = [];

  headArray: any = [
    {
      Head: 'Id',
      FieldName: 'id',
    },
    {
      Head: 'Tipo CVF',
      FieldName: 'poseedor',
      renderValue: (item: any) => item?.poseedor ? 'POSEEDOR' : 'GESTOR',
    },
    {
      Head: 'Id Gestor',
      FieldName: 'gestorResiduos',
      Attribute: 'id',
    },
    {
      Head: 'NIMA Gestor',
      renderValue: (item: any) => item.gestorResiduos?.nima || item.nimaGestor || '',
    },
    {
      Head: 'Razón Social Gestor',
      renderValue: (item: any) => item.gestorResiduos?.razonSocial || item.razonSocialGestor || '',
    },
    {
      Head: 'Documento Gestor',
      renderValue: (item: any) => item.gestorResiduos?.codigoDocumento || item.codigoDocumentoGestor || '',
    },
   {
      Head: 'Estado Gestor',
      FieldName: 'gestorResiduos',
      renderValue: (item: any) => item?.gestorResiduos?.gestoresResiduosEstado?.descripcion,
    },
    {
      Head: 'Id Poseedor',
      FieldName: 'poseedor',
      Attribute: 'id',
    },
    {
      Head: 'NIMA Poseedor',
      FieldName: 'poseedor',
      Attribute: 'nima',
    },
    {
      Head: 'Razón Social Poseedor',
      FieldName: 'poseedor',
      Attribute: 'razonSocial',
    },
    {
      Head: 'Documento Poseedor',
      FieldName: 'poseedor',
      Attribute: 'codigoDocumento',
    },
    {
      Head: 'Estado Poseedor',
      FieldName: 'poseedor',
      renderValue: (item: any) => item?.poseedor?.estado?.descripcion,
    },
    {
      Head: 'Estado cvf',
      FieldName: 'estado',
      Attribute: 'descripcion',
    },
    {
      Head: 'Cantidad (t)',
      renderValue: (item: any) => {
        let total = 0;
        if (item.cvfCodLerOperacion && Array.isArray(item.cvfCodLerOperacion)) {
          total = item.cvfCodLerOperacion.reduce((acc: number, curr: any) => acc + (curr.cantidad || 0), 0);
        } else {
          total = item.cantidad || 0;
        }
        return new Intl.NumberFormat('es-ES', { minimumFractionDigits: 5, maximumFractionDigits: 5 }).format(total);
      }
    },
    {
      Head: 'Fecha de finalización',
      FieldName: 'fechaFinalizacionCvf',
      renderValue: (item: any) => this.datePipe.transform(item.fechaFinalizacionCvf, 'dd/MM/yyyy'),
    },
    {
      Head: 'Año de los datos',
      FieldName: 'anno',
    },
    

    {
      Head: 'Acciones',
      FieldName: 'actions',
      check: true,
      buttons: [
        { nameButton: 'view', icon: 'open_in_new', toolTip: 'Detalle' },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'downloadCVF',
              name: 'Descargar CVF para firma',
              show: { params: 'canDownloadCVF', accion: 'downloadCVF' },
            },
            {
              nameButton: 'sign',
              name: 'Subir CVF Firmado',
              show: { params: 'canSignCVF', accion: 'sign' },
            },
            {
              nameButton: 'downloadSigned',
              name: 'Descarga CVF Firmado',
              show: { params: 'canDownloadSignedCVF', accion: 'downloadSigned' },
            },
            {
              nameButton: 'downloadCompleted',
              name: 'Descarga CVF Completado',
              show: { params: 'canDownloadCompleted', accion: 'downloadCompleted' },
            },
            {
              nameButton: 'downloadPrefactura',
              name: 'Descargar Prefactura',
              show: { params: 'canDownloadPrefactura', accion: 'downloadPrefactura' },
            },
            {
              nameButton: 'accept',
              name: 'Aceptar CVF',
              show: { params: 'canAccept', accion: 'accept' },
            },
            {
              nameButton: 'reject',
              name: 'Rechazar CVF',
              show: { params: 'canReject', accion: 'reject' },
            },
            {
              nameButton: 'downloadDetail',
              name: 'Descargar detalle aportaciones',
              show: { params: 'canDownloadDetail', accion: 'downloadDetail' },
            },
            {
              nameButton: 'downloadFicheroCVF',
              name: 'Descarga CVF pendiente de cumplimentación',
              show: { params: 'canDownloadFicheroCVF', accion: 'downloadFicheroCVF' },
            },
          ],
        },

      ],
      width: '10',
      permanent: true,
    },
  ];

  gridArray: any[] = [];
  generateForm: FormGroup;
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    public spinnerSrv: SpinnerService,
    private comboService: ComboService,
    private snackBarSrv: SnackbarService,
    private route: ActivatedRoute,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private cvfControllerService: CvfControllerService,
    private CvfEstadosControllerService: CvfEstadosControllerService,
    private aportacionDIPoseedorService: AportacionDIPoseedorControllerService,
    private downloadService: DownloadService,
    private cvfService: CvfControllerService,
    private documentService: DocumentService,
    private datePipe: DatePipe,
    private poseedorEstadoControllerService: PoseedorEstadoControllerService,
    private gestoresResiduosEstadosControllerService: GestoresResiduosEstadosControllerService,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    this.generateForm = this.formBuilder.group({
      id: [{ value: null, disabled: false }],
      tipoCvf: [{ value: null, disabled: false }],
      anno: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      reabierto: [{ value: false, disabled: false }],
      idGestor: [{ value: null, disabled: false }],
      nimaGestor: [{ value: null, disabled: false }],
      razonSocialGestor: [{ value: null, disabled: false }],
      estadoGestor: [{ value: null, disabled: false }],
      documentoGestor: [{ value: null, disabled: false }],
      idPoseedor: [{ value: null, disabled: false }],
      nimaPoseedor: [{ value: null, disabled: false }],
      razonSocialPoseedor: [{ value: null, disabled: false }],
      estadoPoseedor: [{ value: null, disabled: false }],
      documentoPoseedor: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }
  ngOnInit(): void {
    const state: any = history.state;
    if (state && state.searchForm) {
      this.searchFormState = state.searchForm;
      console.log('[HoldersCvfSearch ngOnInit] Capturado searchFormState:', this.searchFormState);
    }
    this.route.queryParams.subscribe(params => {
      // Intentamos leer de queryParams por si acaso (compatibilidad), luego de nav state (transiciones), o finalmente localStorage
      const typeFromParams = params['type'] || history.state.type;
      if (typeFromParams) {
        localStorage.setItem('cvfTypeFromRoute', typeFromParams);
        this.cvfTypeFromRoute = typeFromParams;
      } else {
        this.cvfTypeFromRoute = localStorage.getItem('cvfTypeFromRoute');
      }
      this.configurarSegunRuta();
      this.modificarTablaPorRol();
    });
    this.comboEstados();
    this.tipoCvfArray = this.comboService.getComboTiposCVF();
    this.comboEstadosPoseedores();
    this.comboEstadosGestores();
    this.comboOrden();
  }

  configurarSegunRuta() {
    const anioPorDefecto = new Date().getFullYear() - 1;
    if (this.cvfTypeFromRoute) {
      this.generateForm.get('anno')?.setValue(anioPorDefecto);
      if (this.cvfTypeFromRoute === 'gestor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFGestor');
      } else if (this.cvfTypeFromRoute === 'poseedor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFPoseedor');
      }
      this.buscar();
    } else if (anioPorDefecto && (this.cvfTypeFromRoute === 'gestor' || this.cvfTypeFromRoute === 'poseedor')) {
      this.generateForm.get('anno')?.setValue(anioPorDefecto);
      
      if (this.cvfTypeFromRoute === 'gestor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFGestor');
      } else if (this.cvfTypeFromRoute === 'poseedor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFPoseedor');
      }

      this.buscar();
    }
  }

  modificarTablaPorRol() {
    const isGestorEnv = this.canViewResource('PO-ENV-GEST');
    const isGestor = this.cvfTypeFromRoute === 'gestor';
    const isPoseedor = this.cvfTypeFromRoute === 'poseedor';

    const actionsCol = this.headArray.find((col: any) => col.Head === 'Acciones');
    if (actionsCol) {
      actionsCol.check = isGestorEnv;
    }

    if (isGestorEnv) {
      this.headArrayModificado = [...this.headArray];
    } else if (isGestor) {
      this.headArrayModificado = this.headArray.filter((col: any) => 
        !col.Head.includes('Poseedor') && col.Head !== 'Tipo CVF' && col.Head !== 'Estado Gestor'
      );
    } else if (isPoseedor) {
      this.headArrayModificado = this.headArray.filter((col: any) =>
        col.Head !== 'Tipo CVF' &&
        col.Head !== 'Estado Gestor' &&
        col.Head !== 'Estado Poseedor' &&
        col.Head !== 'Id Gestor'
      );
    } else {
      this.headArrayModificado = this.headArray.filter((col: any) => col.Head !== 'Tipo CVF');
    }
  }

  private getBackendFilter() {
    const removeEmpty = (obj: any) => {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
          delete obj[key];
        }
      });
      return obj;
    };

    const getTrimmed = (controlName: string) => {
    const value = this.generateForm.get(controlName)?.value;
    return typeof value === 'string' ? value.trim() : value;
    
      };
    const selectEstadoPoseedor = this.generateForm.get('estadoPoseedor')?.value;
    let selectEstadosIdPoseedor: any[] = [];
    if (selectEstadoPoseedor !== undefined && selectEstadoPoseedor !== null) {
      selectEstadosIdPoseedor = selectEstadoPoseedor.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    let poseedorFilter = removeEmpty({
      id: getTrimmed('idPoseedor'),
      razonSocial: this.generateForm.get('razonSocialPoseedor')?.value ? this.generateForm.get('razonSocialPoseedor')?.value.trim() : undefined,
      nima: this.generateForm.get('nimaPoseedor')?.value,
      codigoDocumento: this.generateForm.get('documentoPoseedor')?.value,
      estado: { id: selectEstadosIdPoseedor },
    });
    const selectEstadoGestor = this.generateForm.get('estadoGestor')?.value;
    let selectEstadosIdGestor: any[] = [];
    if (selectEstadoGestor !== undefined && selectEstadoGestor !== null) {
      selectEstadosIdGestor = selectEstadoGestor.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    let gestorFilter = removeEmpty({
      id: getTrimmed('idGestor'),
      razonSocial: this.generateForm.get('razonSocialGestor')?.value ? this.generateForm.get('razonSocialGestor')?.value.trim() : undefined,
      nima: this.generateForm.get('nimaGestor')?.value,
      codigoDocumento: this.generateForm.get('documentoGestor')?.value,
      gestoresResiduosEstado: { id: selectEstadosIdGestor },
    });

    const selectEstado = this.generateForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    let backendFilter: CvfFilterDTO = removeEmpty({
      tipoCvf: this.generateForm.get('tipoCvf')?.value,
      id: getTrimmed('id'),
      anno: this.generateForm.get('anno')?.value,
      estado: { id: selectEstadosId },
      reabierto: this.generateForm.get('reabierto')?.value ?? false,
      poseedor: Object.keys(poseedorFilter).length > 0 ? poseedorFilter : undefined,
      gestorResiduos: Object.keys(gestorFilter).length > 0 ? gestorFilter : undefined,
    });

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.generateForm.get('orden')?.value;
    const tipoOrden = this.generateForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

    buscar(){

    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();

    this.modificarTablaPorRol();

    this.cvfControllerService.findAll14(backendFilter,{page: page, size: size, sort:['id,desc']},
        orden,
        tipoOrden
)
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.flagSearch = data.datos?.length !== 0 ? true : false;
            this.gridArray = data.datos ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;

            this.calculateActions(this.gridArray);
            this.totalSearch = this.gridArray.length;
          }
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  calculateActions(data: any[]) {
    const isGestorEnv = this.canViewResource('PO-ENV-GEST');
    const isGestor = this.cvfTypeFromRoute === 'gestor';
    const isPoseedor = this.cvfTypeFromRoute === 'poseedor';

    data.forEach(item => {
        const estado = item.estado?.id;
        
        // "Descarga CVF Completado" es para el 'PO-GESTOR' a partir del estado FINALIZADO.
        item.canDownloadCompleted = (isGestor || isGestorEnv) && (estado === 2 || estado === 3 || estado === 5) && !item.poseedor;

        // "Descargar Prefactura" para 'PO_GESTOR' y 'PO-ENV-GEST' si está en estado PREFACTURADO.
        item.canDownloadPrefactura = (isGestor || isGestorEnv) && estado === 3;

        // "Aceptar CVF" solo para el 'PO-ENV-GEST' y para estado FINALIZADO.
        item.canAccept = isGestorEnv && ((estado === 2 && !item.poseedor) || (estado === 2 && item.poseedor));

        // "Rechazar CVF" solo para el 'PO-ENV-GEST' y para estado FINALIZADO.
        item.canReject = isGestorEnv && ((estado === 2 && !item.poseedor) || ((estado === 2 || estado === 5 || estado === 6 || estado === 7) && item.poseedor));

        // "Subir CVF Firmado" para 'PO-POSEEDOR' y 'PO-ENV-GEST' si el estado es PDTE. FIRMA.
        item.canSignCVF = isPoseedor && (estado === 6 || estado === 7);

        // "Descarga CVF Firmado" para 'PO-POSEEDOR' y 'PO-ENV-GEST' si el estado es FIRMADO.
        item.canDownloadSignedCVF = (isPoseedor || isGestorEnv) && ((estado === 2 || estado === 5 || estado === 7) && item.poseedor);

        // "Descargar CVF para firmar" para 'PO-POSEEDOR' y 'PO-ENV-GEST' si el estado es PDTE. FIRMA.
        item.canDownloadCVF = (isPoseedor || isGestorEnv) && (estado === 6 || estado === 7);

        // "Descargar CVF" para 'PO-POSEEDOR' y 'PO-ENV-GEST' si el estado es PDTE. FIRMA.
        item.canDownloadFicheroCVF = (isPoseedor || isGestorEnv) && item.poseedor;
        
        item.canDownloadDetail = true;
    });
  }

  limpiar(): void {
    this.generateForm.reset();
    this.generateForm.get('reabierto')?.setValue(false);
    this.flagSearch = false;
    this.gridArray = [];

    const anioPorDefecto = new Date().getFullYear() - 1;
    if (this.cvfTypeFromRoute) {
      this.generateForm.get('anno')?.setValue(anioPorDefecto);
      if (this.cvfTypeFromRoute === 'gestor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFGestor');
      } else if (this.cvfTypeFromRoute === 'poseedor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFPoseedor');
      }
    } else if (this.cvfTypeFromRoute === 'gestor' || this.cvfTypeFromRoute === 'poseedor') {
      this.generateForm.get('anno')?.setValue(anioPorDefecto);
      if (this.cvfTypeFromRoute === 'gestor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFGestor');
      } else if (this.cvfTypeFromRoute === 'poseedor') {
        this.generateForm.get('tipoCvf')?.setValue('CVFPoseedor');
      }
    }
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.generateForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v: any) => {
          if (typeof v === 'object' && typeof filtro.value === 'object') {
            const currentId = v?.id ?? v;
            const targetId = filtro.value?.id ?? filtro.value;
            return currentId !== targetId;
          }
          return v !== filtro.value;
        });
        this.generateForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.generateForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 0;
    //this.buscar();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const id = this.generateForm.get('id')?.value;
    if (id) filtros.push({ label: ` ${id}`, campo: 'id' });

    const tipoCvf = this.generateForm.get('tipoCvf')?.value;
    if (tipoCvf) {
      const found = this.tipoCvfArray.find((t: any) => t.id === tipoCvf);
      filtros.push({ label: ` ${found?.name ?? tipoCvf}`, campo: 'tipoCvf' });
    }

    const anno = this.generateForm.get('anno')?.value;
    if (anno) filtros.push({ label: `${anno}`, campo: 'anno' });

    const estados = this.generateForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estado: any) => {
        filtros.push({
          label: ` ${estado?.descripcion ?? String(estado)}`,
          campo: 'estado',
          value: estado,
        });
      });
    }

    const reabierto = this.generateForm.get('reabierto')?.value;
    if (reabierto === true) filtros.push({ label: 'Sí', campo: 'reabierto' });

    const idGestor = this.generateForm.get('idGestor')?.value;
    if (idGestor) filtros.push({ label: ` ${idGestor}`, campo: 'idGestor' });

    const nimaGestor = this.generateForm.get('nimaGestor')?.value;
    if (nimaGestor?.trim()) filtros.push({ label: ` ${nimaGestor.trim()}`, campo: 'nimaGestor' });

    const razonSocialGestor = this.generateForm.get('razonSocialGestor')?.value;
    if (razonSocialGestor?.trim()) filtros.push({ label: ` ${razonSocialGestor.trim()}`, campo: 'razonSocialGestor' });

    const documentoGestor = this.generateForm.get('documentoGestor')?.value;
    if (documentoGestor?.trim()) filtros.push({ label: `${documentoGestor.trim()}`, campo: 'documentoGestor' });

    const estadoGestor = this.generateForm.get('estadoGestor')?.value as any[];
    if (estadoGestor?.length) {
      estadoGestor.forEach((estadoId: any) => {
        const found = this.estadosGestorArray.find((e: any) => e.id === estadoId);
        filtros.push({
          label: ` ${found?.descripcion ?? String(estadoId)}`,
          campo: 'estadoGestor',
          value: estadoId,
        });
      });
    }

    const idPoseedor = this.generateForm.get('idPoseedor')?.value;
    if (idPoseedor) filtros.push({ label: ` ${idPoseedor}`, campo: 'idPoseedor' });

    const nimaPoseedor = this.generateForm.get('nimaPoseedor')?.value;
    if (nimaPoseedor?.trim()) filtros.push({ label: ` ${nimaPoseedor.trim()}`, campo: 'nimaPoseedor' });

    const razonSocialPoseedor = this.generateForm.get('razonSocialPoseedor')?.value;
    if (razonSocialPoseedor?.trim()) filtros.push({ label: ` ${razonSocialPoseedor.trim()}`, campo: 'razonSocialPoseedor' });

    const documentoPoseedor = this.generateForm.get('documentoPoseedor')?.value;
    if (documentoPoseedor?.trim()) filtros.push({ label: ` ${documentoPoseedor.trim()}`, campo: 'documentoPoseedor' });

    const estadoPoseedor = this.generateForm.get('estadoPoseedor')?.value;
    if (estadoPoseedor !== null && estadoPoseedor !== undefined && estadoPoseedor !== '') {
      const found = this.estadosPoseedorArray.find((e: any) => e.id === estadoPoseedor);
      filtros.push({
        label: ` ${found?.descripcion ?? String(estadoPoseedor)}`,
        campo: 'estadoPoseedor',
      });
    }

    const ordenes = this.generateForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.generateForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  checked(element: any) {
    if (!element.checked) return;
  }

  comboEstados() {
      this.CvfEstadosControllerService.findAll16().subscribe({
        next: (data: Array<CvfEstadoDTO>) => {
          this.estadoArray = data;
          this.tryRestoreFormFromStorage();
        },
        error: () => {},
      });
    }

  action(element: any) {
    switch (element.nameButton) {
      case 'view':
      case 'edit':
        this.abrirPantalla(element.id, element.estado?.id);
        break;
      case 'downloadDetail':
        this.confirmarBottonExportar(element);
        break;
      case 'reject':
        this.rechazarCvf(element);
        break;
      case 'accept':
        this.aceptarCvf(element);
        break;
      case 'downloadCompleted':
        this.descargarCVF(element)
        break;
      case 'downloadPrefactura':
        this.descargar(element);
        break;
      case 'sign':
        this.subirCVF(element);
        break;
      case 'downloadSigned':
        this.descargarCVFFirmado(element);
        break;
      case 'downloadFicheroCVF':
        this.descargarFicheroCVF(element);
        break;
      case 'downloadCVF':
        this.descargarCertificadoCVF(element);
        break;

    }
  }

  subirCVF(element: any) {
    const dialogRef = this.dialog.open(HoldersCvfSignedUploadDialogComponent, {
      width: '800px',
      data: { info: element }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscar();
      }
    });
  }

  aceptarCvf(element: any) {
    this.spinnerSrv.loadingShow();
    this.cvfControllerService.aceptarCvf(element.id).subscribe({
      next: () => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar('CVF aceptado correctamente', 'success');
        this.buscar();
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        console.error(err);
        this.snackBarSrv.showSnackBar('Error al aceptar el CVF', 'error');
      }
    });
  }

  rechazarCvf(element: any) {
    const dialogRef = this.dialog.open(HoldersCvfRejectDialogComponent, {
      width: '500px',
      data: { info: element }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscar();
      }
    });
  }

  descargarDetalle(element: any) {
    const filter: any = element?.poseedor
      ? { cvfPoseedor: { id: [element?.id] } }
      : { cvf: { id: [element?.id] } };

    this.spinnerSrv.loadingShow();
    this.aportacionDIPoseedorService.exportCSVCvf(filter, 'response').subscribe((res: any) => {
      const filename = this.downloadService.getFileName(
        res.headers,
        'Detalle_cvf.xlsx'
      );
      this.downloadService.downloadBlob(res.body!, filename!);
      this.spinnerSrv.loadingHide();
    });
  }

  exportarExcel() {

    const { backendFilter, page, size } = this.getBackendFilter();

    this.cvfControllerService.exportCSV4(backendFilter,  'response').subscribe({
      next: (response: any) => {
        this.downloadService.exportModal();
      }
    });
  }

  compareEstado = (e1: any, e2: any): boolean => {
    if (!e1 || !e2) return e1 === e2;
    return e1.id === e2.id;
  }

  tryRestoreFormFromStorage() {
    const storedForm = sessionStorage.getItem('holdersCvfSearchForm');
    if (storedForm && this.estadoArray.length > 0) {
      try {
        const formValue = JSON.parse(storedForm);
        this.generateForm.patchValue(formValue);
        this.buscar();
        sessionStorage.removeItem('holdersCvfSearchForm');
        console.log('[HoldersCvfSearch tryRestoreFormFromStorage] Formulario restaurado correctamente');
      } catch (e) {
        console.error('[HoldersCvfSearch tryRestoreFormFromStorage] Error al restaurar formulario', e);
      }
    }
  }

  abrirPantalla(id: number, estadoId: number): void {
    let isEditable = false;

    if (this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')) {
      isEditable = false;
    } else if (this.cvfTypeFromRoute === 'gestor' || this.cvfTypeFromRoute === 'poseedor') {
      isEditable = (estadoId === 1);
    }

    const formValue = this.generateForm.getRawValue();
    sessionStorage.setItem('holdersCvfSearchForm', JSON.stringify(formValue));
    console.log('[HoldersCvfSearch abrirPantalla] Guardado searchFormState en sessionStorage');
    this.router.navigate(['/holders/holders-cvf-detail', id], { state: { isEditable: isEditable, searchForm: formValue } });
  }

  crearAutoFactura(){
    const selected = this.gridArray.filter(x => x.checked);

    if (selected.length === 0) {
      this.snackBarSrv.showSnackBar('Debe seleccionar al menos un registro', 'error', 3000);
      return;
    }

    const invalidState = selected.some(x => x.estado?.id !== 5);
    if (invalidState) {
      this.snackBarSrv.showSnackBar('Solo se permitirá prefacturar CVF en estado Aceptado', 'error', 3000);
      return;
    }

    const invalidType = selected.some(x => x.poseedor && x.poseedor.id);
    if (invalidType) {
      this.snackBarSrv.showSnackBar('Solo se permitirá prefacturar CVF de tipo gestor', 'error', 3000);
      return;
    }

    this.spinnerSrv.loadingShow();
      this.cvfControllerService.generarAutoFactura(selected)
        .subscribe({
          next: (response: any) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Se ha generado la prefactura correctamente.',
              'success'
            );
            this.buscar();
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            let message = err.error?.arguments[0] ?? 'Ha ocurrido un error al generar la prefactura';
            this.snackBarSrv.showSnackBar(message, 'error');
          },
        });


  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.buscar();
    }
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.buscar();
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  showClearButton(formName: string): boolean {
    return this.generateForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.generateForm.get(formName)?.setValue(null);
  }

  descargarCVF(element: any){


    this.spinnerSrv.loadingShow();
    this.cvfService.exportarCVF(element?.id, 'response')
      .subscribe((res: any) => {
        const filename = this.downloadService.getFileName(
          res.headers,
          'Cvf.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
        this.spinnerSrv.loadingHide();
      });
  }

  descargarFicheroCVF(element: any){
    this.spinnerSrv.loadingShow();
    this.cvfService.exportarCvfPoseedorPendiente(element?.id, 'response')
      .subscribe((res) => {
        const filename = this.downloadService.getFileName(
          res.headers,
          'FicheroCVFCumplimentacion.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
        this.spinnerSrv.loadingHide();
      });
  }

  descargarCertificadoCVF(element: any){
    this.spinnerSrv.loadingShow();
    this.cvfControllerService.crearCertificado(element?.id, 'response')
      .subscribe({
        next: (res: any) => {
          const filename = this.downloadService.getFileName(
            res.headers,
            'CVF.pdf'
          );
          this.downloadService.downloadBlob(res.body as any, filename!);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        }
      });
  }

  descargarCVFFirmado(element: any) {
    if (element?.documento?.id) {
      this.spinnerSrv.loadingShow();
      this.documentService.descargarDocumento(element.documento.id).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha descargado el documento correctamente',
            'success'
          );
          this.downloadService.downloadBlob(response, element.documento.nombre);
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    } else {
      this.snackBarSrv.showSnackBar('No hay documento firmado disponible', 'error');
    }
  }

   descargar(element: any) {
    this.spinnerSrv.loadingShow();
    this.documentService.descargarDocumento(element?.prefactura?.documentoAutofactura?.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, element?.prefactura?.documentoAutofactura?.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

    comboEstadosPoseedores() {
    this.poseedorEstadoControllerService.findAll6().subscribe({
      next: (data: any) => {
        this.estadosPoseedorArray = data!;
      },
      error: () => { },
    });
  }

    comboEstadosGestores() {
    this.gestoresResiduosEstadosControllerService.findAll9().subscribe({
      next: (data: any) => {
        this.estadosGestorArray = data!;
      },
      error: () => {},
    });
  }
  
    confirmarBottonExportar(element: any) {

      if(!this.esGestorResiduos()){
        this.descargarDetalle(element);
        return;
      }
      swal.fire({
        text: 'Para descargar el detalle de las aportaciones contabilizadas en el CVF, debe confirmar que garantiza la confidencialidad y el correcto tratamiento de los datos de sus clientes poseedores finales.',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirmar',
        denyButtonText: 'Cancelar',
        allowOutsideClick: false,
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.descargarDetalle(element);
        }
      });
    }

      esGestorResiduos(){
    return (this.canViewRol('PO-GESTOR'));
  }

    canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  comboOrden() {
    this.diccionarioControllerService.listarElementos(['ORDEN_CVF_BUSQUEDA']).subscribe({
      next: (data: any) => {
        this.orden = data['ORDEN_CVF_BUSQUEDA'];
      },
      error: () => { },
    });
  }
}
